// https://redux-toolkit.js.org/tutorials/typescript#define-typed-hooks
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import type { RootState, AppDispatch } from './store'
import { DatabaseContext } from 'web/db_context';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()

export const useDatabase = () => useContext(DatabaseContext)!;
export const useTaxonomy = () => useDatabase().taxonomy;
export const useGeography = () => useDatabase().geography;
